import { formatMoney } from 'accounting';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../common/type';
import { Button } from '../../../components/Button';
import { Field } from '../../../components/Control/Field';
import { Input } from '../../../components/Control/Input';
import { Label } from '../../../components/Control/Label';
import { Select } from '../../../components/Control/Select';
import { is } from '../../../util/is';
import { getClassName } from '../../../util/string-util';
import { adsCheckoutActionCreator } from '../parts/ads-checkout-action';
import {
  createDiscountedPriceSelector,
  selectAdBasePrice,
  selectAdInfo,
  selectAdsTypeInfo
} from '../parts/ads-checkout-selector';
import { IAdsTypeInfo } from '../parts/ads-checkout-type';

class AdsSelectionRecordContainer extends React.Component<IProps> {
  render() {
    const props = this.props;
    return (
      <div className="ads-selection--record">
        <div className="ads-selection--record-fields">
          <Field fieldId={`title-${props.index}`}>
            <Label>Title</Label>
            <Input value={props.name} onChangeValue={props.invokeSetName} autoFocus={true} />
          </Field>
          <Field fieldId={`typeId-${props.index}`}>
            <Label>Type</Label>
            <Select value={props.typeId} onChangeValue={props.invokeSetType} required={true}>
              {props.adsTypes.map(adsType => (
                <option value={adsType.idKey} key={adsType.idKey}>
                  {adsType.name}
                </option>
              ))}
            </Select>
          </Field>
        </div>
        <div className="ads-selection--record-toolbar">
          <div className="ads-selection--record-pricing">
            Price:{' '}
            <span className={getClassName(!is.Nil(props.discountedPrice) && 'strikethrough')}>
              {props.basePrice}
            </span>
            {!is.Nil(props.discountedPrice) && <span> {props.discountedPrice}</span>}
          </div>
          <Button onClick={props.invokeRemove}>Remove</Button>
        </div>
      </div>
    );
  }
}

interface IParentProps {
  index: number;
}

interface IStoreProps {
  typeId: string;
  name: string;
  adsTypes: IAdsTypeInfo[];
  basePrice: string;
  discountedPrice: string | undefined;
}

interface IDispatchProps {
  invokeSetName: (name: string) => void;
  invokeSetType: (typeId: string) => void;
  invokeRemove: () => void;
}

type IProps = IParentProps & IStoreProps & IDispatchProps;

// returns a function instead of object for the selector memoization to work,
// for more details, see https://github.com/reduxjs/reselect#sharing-selectors-with-props-across-multiple-component-instances
const createMapStates = () => {
  const selectDiscountedPrice = createDiscountedPriceSelector();

  return (state: IStore, ownProps: IParentProps): IStoreProps => {
    const adInfo = selectAdInfo(state, ownProps.index);
    const basePrice = selectAdBasePrice(state, ownProps.index);
    const discountedPrice = selectDiscountedPrice(state, ownProps.index);

    return {
      typeId: is.Nil(adInfo) ? '' : adInfo.typeId,
      name: is.Nil(adInfo) ? '' : adInfo.name,
      adsTypes: selectAdsTypeInfo(state),
      basePrice: is.Nil(basePrice) ? 'Unknown' : formatMoney(basePrice),
      discountedPrice: is.Nil(discountedPrice) ? undefined : formatMoney(discountedPrice as number)
    };
  };
};

const mapDispatch = (dispatch: Dispatch, ownProps: IParentProps): IDispatchProps => ({
  invokeSetName: name => dispatch(adsCheckoutActionCreator.SetAdsName(ownProps.index, name)),
  invokeSetType: typeId => dispatch(adsCheckoutActionCreator.SetAdsType(ownProps.index, typeId)),
  invokeRemove: () => dispatch(adsCheckoutActionCreator.RemoveAds(ownProps.index))
});

export const AdsSelectionRecord = connect(
  createMapStates,
  mapDispatch
)(AdsSelectionRecordContainer);



// WEBPACK FOOTER //
// ./src/modules/ads-checkout/components/AdsSelectionRecord.tsx